import { /* baseClient, */ authClient, API } from '../../utils/index'

// Get all sailors
export const getSailors = () => {
  return authClient().get(`${API}/sailor`)
}

// Get sailor by id
export const getSailorById = (id) => {
  return authClient().get(`${API}/sailor/${id}`)
}

// Delete sailor
export const deleteSailor = (id) => {
  return authClient().delete(`${API}/sailor/${id}`)
}

// Create sailor
export const postSailor = (sailor) => {
  return authClient().post(`${API}/sailor`, sailor)
}

// Update sailor
export const updateSailor = (id, sailor) => {
  return authClient().put(`${API}/sailor/${id}`, sailor)
}
